<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-buttons
                [grid]="grid"
                [canEdit]="canEdit"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid
            id="mainGrid"
            #mainGrid
            appAutoSize
            (initialized)="grid.initialize(mainGrid)"
            (destroy)="grid.destroy()"
            [itemsSource]="grid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Vista Job'" [binding]="'vpJobId'" [width]="110"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Description'" [binding]="'jobDescription'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Schedule Ref'" [binding]="'scheduleReference'" [width]="130"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Internal'" [binding]="'isInternal'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Active'" [binding]="'active'" [width]="70"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
